import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { CreateProcedureInitiativeViewTopBar } from "./TopBar"

export const createProcedureInitiativeViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: CreateProcedureInitiativeViewTopBar,
}
